import getAPIResponse from 'Shared/Utils/Domain/Services/GetAPIResponsePrivateService';

/**
 * Obtiene las reuniones asociadas a una propuesta de mejora
 * @param {number|string} id
 * @returns {Promise<Array>} Lista de reuniones
 */
export async function getImprovementProposalMeetings(id) {
  if (!id) return [];
  try {
    const resp = await getAPIResponse(`/v1/improvement-proposal/${id}/meeting`);
    return Array.isArray(resp) ? resp : [];
  } catch (e) {
    return [];
  }
}
